"use strict";

exports.__esModule = true;
exports.fitFontSize = exports.approximateFontSize = void 0;
var _guessRelativeTextSize = require("./guessRelativeTextSize");
/**
 * A configured font size is a maximum: when the text would not fit the
 * container at that size, fall back to the size that fits.
 */
var fitFontSize = exports.fitFontSize = function fitFontSize(fontSize, autoSize) {
  return fontSize ? Math.min(fontSize, autoSize) : autoSize;
};

/**
 * Approximate the appropriate font size for a container given
 * a width, height and value.
 */
var approximateFontSize = exports.approximateFontSize = function approximateFontSize(_ref) {
  var width = _ref.width,
    height = _ref.height,
    value = _ref.value;
  return Math.floor(Math.max(Math.min(width / ((0, _guessRelativeTextSize.guessRelativeTextSize)(value ? String(value) : "") * 0.8), height - 4), 8));
};